export const queryPage = '/icps/system/sign/intelligent/seriflux/queryPage'
export const saveOrUpdate = '/icps/system/sign/intelligent/seriflux/saveSolidContent'
import request from "@/utils/request";
/*检验记录*/
export function queryDetectoinLogPage(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/seriflux/queryDetectoinLogPage",
    method: "post",
    data,
  });
}